import router, { getAuthorizedEntryPath, publicRoutePaths, syncRoutesFromMenuTree } from '@/router'
import store from '@/store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { Message } from 'element-ui'
import Api from './api/index'
import {
  getBrowserFingerprint,
  getLoginFingerprint,
  saveLoginFingerprint
} from '@/utils/fingerprint'
NProgress.configure({ showSpinner: false })

const whiteList = publicRoutePaths // 不重定向白名单
function isWhiteListRoute(route) {
  return whiteList.includes(route.path)
    || route.matched.some(record => whiteList.includes(record.path))
}
// 查看token是否过期
function checkTokenTimeStamp() {
  let userInfo = localStorage.getItem("userInfo") && JSON.parse(localStorage.getItem("userInfo"));
  let tokenTimeStamp = userInfo?.auth?.access_expire;
  // 没有token时间戳，视为过期
  if (!tokenTimeStamp) {
    console.log('[Token] 无过期时间戳，视为失效')
    return false;
  }
  const currentTimeStamp = Math.floor(Date.now() / 1000);
  const diff = tokenTimeStamp - currentTimeStamp; // 时间差（秒）
  const ONE_DAY = 24 * 60 * 60; // 86400秒
  if (diff <= 0) {
    console.log('[Token] 已过期')
    return false;
  }
  if (diff < ONE_DAY) {
    console.log(`[Token] 将在一天内过期，剩余 ${Math.floor(diff / 3600)} 小时`)
    Api.refreshAccessToken({refresh_token: userInfo?.auth?.refresh_token}).then(res => {
      console.log('[Token] 刷新成功', res)
      if(res.code === 200) {
        console.log('[Token] 刷新成功，更新token')
        userInfo.auth=res.data||{};
        localStorage.setItem('token', res.data.access_token)
        localStorage.setItem('userInfo', JSON.stringify(userInfo))
        store.commit('user/SET_TOKEN', res.data.access_token || '')
        store.commit('user/SET_USER_INFO', userInfo)
      }
    })   
    return true;
  }
  console.log(`[Token] 有效，剩余 ${Math.floor(diff / ONE_DAY)} 天`)
  return true;
}
router.beforeEach(async (to, from, next) => {
  NProgress.start()
  const token = localStorage.getItem('token');
  // 白名单页面直接放行
  if (isWhiteListRoute(to)) {
    next()
    return
  }
  if (!token) {
    // 无token，跳登录
    next(`/login?redirect=${to.path}`)
    NProgress.done()
    return
  }
  const routesChanged = syncRoutesFromMenuTree()
  if (routesChanged) {
    next({ ...to, replace: true })
    return
  }
  console.log('fullPathfullPath', to.fullPath)
  if (!router.match(to.fullPath).matched.length) {
    Message.warning('当前账号暂无该页面访问权限')
    NProgress.done()
    next(getAuthorizedEntryPath())
    return
  }
  // 有token，检查是否过期
  const isValid = checkTokenTimeStamp();
  if (!isValid) {
    // token过期，清除所有缓存，跳登录
    localStorage.clear()
    next(`/login?redirect=${to.path}`)
    NProgress.done()
    return
  }
  try {
    const currentFingerprint = await getBrowserFingerprint(true)
    const loginFingerprint = getLoginFingerprint()

    // 兼容升级前已经登录、尚未保存基准指纹的会话。
    if (!loginFingerprint) {
      saveLoginFingerprint(currentFingerprint)
    } else if (currentFingerprint !== loginFingerprint) {
      store.commit('user/CLEAR_USER')
      Message.warning('检测到登录环境发生变化，请重新登录')
      next({
        path: '/login',
        query: {
          redirect: to.fullPath,
          reason: 'fingerprint_mismatch'
        }
      })
      NProgress.done()
      return
    }
  } catch (error) {
    console.warn('[Fingerprint] 路由指纹校验失败:', error)
  }
  // token有效，正常放行
  next()
})

router.afterEach(() => {
  NProgress.done()
})
